export default __webpack_public_path__ + "static/media/placeholder_store03-it-web.3e4f0ece.png";